import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useProductSelectSearch } from '@/hooks/useProductSelectSearch';
import { useSelectLabels } from '@/hooks/useSelectLabels';
import type { ProductResponse } from '@/types/product';

export interface ProductSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onProductChange?: (product: ProductResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

/** Searchable product picker — server search by name, SKU, or barcode. */
export function ProductSelect({
  label = 'Product',
  value = '',
  onChange,
  onProductChange,
  placeholder,
  disabled,
  className,
  required,
  error,
  name,
}: ProductSelectProps) {
  const selectLabels = useSelectLabels();
  const { options, loading, searching, onSearchQuery, getProduct } = useProductSelectSearch({ value });

  const handleChange = (next: string) => {
    onChange?.(next);
    onProductChange?.(next ? getProduct(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder ?? selectLabels.selectProduct}
        disabled={disabled}
        loading={loading}
        searching={searching}
        searchPlaceholder={selectLabels.searchProductDetail}
        emptyMessage={selectLabels.noProducts}
        filterLocally={false}
        onSearchQuery={onSearchQuery}
      />
    </div>
  );
}
